import React from "react";
import Icon from "../ui/icon";
import "../../assets/styles/auth/notAuthMessage.css";

const NotAuthorizedMessage = () => {
    return (
        <section className="not-authorized-section">
            <div className="container">
                <Icon name="NoSymbol" />
                <h1>Access Denied</h1>
                <p>You do not have permission to view this page.</p>
            </div>
        </section>
    );
};

export default NotAuthorizedMessage;